// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"299524aa","453":"926385ba","828":"dbed972f"}[chunkId] + ".chunk.js";
};